import type { CSSProperties, SVGProps } from 'react'
import classes from './icon.module.css'

type Props = SVGProps<SVGSVGElement> & {
  className?: string
  style?: CSSProperties
}
export function Collapse(props: Props) {
  const { className, style, ...rest } = props

  const cls = `${classes.root} ${className || ''}`
  return (
    <svg
      aria-hidden="true"
      className={cls}
      focusable="false"
      viewBox="0 0 24 24"
      {...rest}
      data-testid="Collapse"
      style={style}
    >
      <path d="M7.41 18.59 8.83 20 12 16.83 15.17 20l1.41-1.41L12 14zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10z" />
    </svg>
  )
}
